import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import StrategyMarketForm from "./StrategyMarketForm";

export default function StrategyMarketPage() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <StrategyMarketForm />
    </DashboardLayout>
  );
}
